/*
  Free gifts leave the cart with their offer (snippets/nr-cart-gifts.liquid).

  A volume tier's free gifts go in as their own lines, marked
  _appstle_bundle_combo_id: free_gift, and Appstle's discount function makes
  them free only while the tier's packs are in the cart. Lower the packs or
  remove them and the gifts would stay at full price, with no buttons to
  remove them (the cart shows them as "Free gift"). So after every cart
  change, and on a page that loads with such a cart, any gift line that is
  being charged for is taken out, and the cart drawer, the cart page and the
  cart count are redrawn here, totals included (Dawn's own redraw after an
  outside change leaves the drawer's and the cart page's totals as they were).
*/
(() => {
  if (window.nrCartGifts) return;
  window.nrCartGifts = true;

  const SOURCE = 'nr-cart-gifts';
  let busy = false;

  const charged = (cart) =>
    (cart?.items || []).filter(
      (item) => item.properties?._appstle_bundle_combo_id === 'free_gift' && item.final_line_price > 0,
    );

  const check = async (cart) => {
    if (busy) return;
    busy = true;
    try {
      if (!Array.isArray(cart?.items)) cart = await fetch(`${routes.cart_url}.js`).then((response) => response.json());
      const gifts = charged(cart);
      if (!gifts.length) return;

      // What to redraw, as Dawn's drawer and cart page do after their own
      // changes: [element, section id, part of the section].
      const parts = [[document.getElementById('cart-icon-bubble'), 'cart-icon-bubble', '.shopify-section']];
      const drawerInner = document.querySelector('cart-drawer .drawer__inner');
      if (drawerInner) parts.push([drawerInner, 'cart-drawer', '.drawer__inner']);
      for (const id of ['main-cart-items', 'main-cart-footer']) {
        const section = document.getElementById(id);
        if (section?.dataset.id) parts.push([section.querySelector('.js-contents'), section.dataset.id, '.js-contents']);
      }

      const updates = Object.fromEntries(gifts.map((item) => [item.key, 0]));
      const response = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({ updates, sections: parts.map(([, id]) => id), sections_url: window.location.pathname }),
      });
      const state = await response.json();
      if (state.errors) return;

      for (const [element, id, selector] of parts) {
        const html = state.sections?.[id];
        if (!element || !html) continue;
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        if (fresh) element.innerHTML = fresh.innerHTML;
      }
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', state.item_count === 0);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: state });
    } catch (error) {
      // Leave the cart as it is; checkout still shows the real total.
    } finally {
      busy = false;
    }
  };

  const start = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === SOURCE) return;
      // A change in the cart sends the whole cart; an add sends only the
      // new line, so the cart is fetched.
      check(event?.source === 'cart-items' ? event.cartData : null);
    });
    if (document.querySelector('[data-nr-charged-gifts]')) check(null);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
